<template>
  <van-popup get-container="body" closeable round position="bottom" v-model="visible" style="padding-top: 4px;">
    <div class="tou1">
      <div class="tou1-1">选择优惠券</div>
    </div>

    <van-tabs class="div-tab" :border="false" @change="onchange" :active="active" :ellipsis="false">
      <van-tab :title="`可用(${useList.length > 0 ? useList.length - 1 : 0})`" name="userAvailableCouponList">
        <div class="zli">
          <div v-if="useList.length>0">
            <!--优惠券 start-->
            <div v-if="couponType == 1">
              <van-radio-group v-model="cradio">
                <div v-for="(item,index) in useList" :key="index">
                  <div v-if="item.userCouponId == -1"  class="co0">
                    <div class="co1">
                      <div class="co1-1 cor-1">
                        <div class="index-list-lefts-1 color3">商品券</div>
                        <div class="cx">
                          <span class="co1-1-x">不使用</span>
                        </div>
                      </div>
                      <div class="co1-2">
                        <p class="co1-2-x">暂不使用优惠券</p>
                        <div class="niu">
                          <van-radio icon-size="16px" checked-color="#F8D541" :name="item.userCouponId"></van-radio>
                        </div>
                      </div> 
                    </div> 
                  </div>
                  <div v-else class="co0">
                    <div class="co1">
                      <div class="co1-1 cor-1">
                        <div class="index-list-lefts-1 color1">商品券</div>
                        <div class="co1-1-0">
                          <span class="co1-1-1">{{item.couponValue}}</span>
                          <span class="co1-1-1-1">元</span>
                        </div>
                        <div class="co1-1-2">满{{item.minimumAmount}}元使用</div>
                      </div>
                      <div class="co1-2">
                        <p class="co1-2-1">{{item.name || '无优惠券名称'}}</p>
                        <div class="co1-2-2">
                          <p class="co1-2-2-1">{{item.beginTime && item.endTime && (item.beginTime.split(' ')[0] +'~'+ item.endTime.split(' ')[0])}}</p>
                        </div>
                        <div class="niu">
                          <van-radio icon-size="16px" checked-color="#F8D541" :name="item.userCouponId"></van-radio>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-radio-group>
            </div>
            <!--优惠券 end -->

            <!--运费券 start -->
            <div v-if="couponType == 2">
              <van-radio-group v-model="fradio">
                <div v-for="(item,index) in useList" :key="index">
                  <div v-if="item.userCouponId == -1"  class="co0">
                    <div class="co1">
                      <div class="co1-1 cor-1">
                        <div class="index-list-lefts-1 color3">运费券</div>
                        <div class="cx">
                          <span class="co1-1-x">不使用</span>
                        </div>
                      </div>
                      <div class="co1-2">
                        <p class="co1-2-x">暂不使用运费券</p>
                        <div class="niu">
                          <van-radio icon-size="16px" checked-color="#F8D541" :name="item.userCouponId"></van-radio>
                        </div>
                      </div>
                    </div> 
                  </div>
                  <div v-else class="co0">
                    <div class="co1">
                      <div class="co1-1 cor-2">
                        <div class="index-list-lefts-1 color2">运费券</div>
                        <div class="co1-1-0">
                          <span class="co1-1-1">{{item.couponValue}}</span>
                          <span class="co1-1-1-1">元</span>
                        </div>
                        <div class="co1-1-2">满{{item.minimumAmount}}元使用</div>
                      </div>
                      <div class="co1-2">
                        <p class="co1-2-1">{{item.name || '无运费券名称'}}</p>
                        <div class="co1-2-2">
                          <p class="co1-2-2-1">{{item.beginTime.split(' ')[0]}}~{{item.endTime.split(' ')[0]}}</p>
                        </div>
                        <div class="niu"><van-radio icon-size="16px" checked-color="#F8D541" :name="item.userCouponId" :disabled="!!item.forbiddenChoose"></van-radio></div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-radio-group>
            </div>
            <!--运费券 end -->
          </div>
          <EmptyItem v-else :title="`暂无${couponType== 1?'优惠': '运费'}券`" info></EmptyItem>
        </div>
      </van-tab>
      <van-tab :title="`不可用(${unUserList.length})`" name="userUnavailableCouponList">
        <div class="zli">
          <div v-if="unUserList.length>0">
            <div v-for="(item,index) in unUserList" :key="index">
              <div class="co0">
                <div class="co1">
                  <div class="co1-1 cor-3">
                    <div class="index-list-lefts-1 color3">{{couponType == '1'? '商品券':'运费券'}}</div>
                    <div class="co1-1-0">
                      <span class="co1-1-1">{{item.couponValue}}</span>
                      <span class="co1-1-1-1">元</span>
                    </div>
                    <div class="co1-1-2">满{{item.minimumAmount}}元使用</div>
                  </div>
                  <div class="co1-2">
                    <p class="co1-2-1">{{item.name || '无优惠券名称'}}</p>
                    <div class="co1-2-2">
                      <p class="co1-2-2-1">{{item.beginTime && item.endTime && (item.beginTime.split(' ')[0] +'~'+ item.endTime.split(' ')[0])}}</p>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
          <EmptyItem v-else :title="`暂无${couponType== 1?'优惠': '运费'}券`" info></EmptyItem>
        </div>
      </van-tab>
    </van-tabs>

    <div class="zul">
      <div class="zfot" @click="checkCoupon">确定</div>
    </div>
  </van-popup>
</template>
<script>
import utils from "@/utils/common";
import EmptyItem from '@/views/shareDiscovery/components/emptyItem'

export default {
  name: "coupon-list-item-A",
  props: {
  },
  data() {
    return {
      visible: false,
      couponType: '1',
      useList: [],
      unUserList: [],
      active: 'userAvailableCouponList',
      fradio: 0,
      cradio: 0
    };
  },
  methods: {
    init(couponType, useList, unUserList){
      this.couponType = couponType
      this.useList = JSON.parse(JSON.stringify(useList)) 
      if(this.useList.length > 0){
        this.useList.push({
          couponValue : '不使用',
          userCouponId: -1
        })
      }
      this.unUserList = JSON.parse(JSON.stringify(unUserList)) 
      this.visible = true
    },
    /**
     * 切换可用不可用列表
     */
    onchange(tab) {
      this.active = tab
    },
    checkCoupon(){
      if(this.active == 'userUnavailableCouponList'){
         this.visible = false
         return
      }else{
        if(this.couponType == 1){
          this.checkCouponByC()
        }
        if(this.couponType == 2){
          this.checkCouponByF()
        }
      }
    },
    /**
     * 选中或取消了优惠券
     */
    checkCouponByC(){
      let row = {}
      //选中
      if(this.cradio && this.cradio !== -1){
        this.useList.forEach(element => {
          if(element.userCouponId == this.cradio){
            row = element
          }
        });
      }
      //取消选中
      if(this.cradio == -1){
        row.userCouponId = ''
        row.couponCancel = 1
      }
      //console.log(row)
      this.$emit('checkCouponACallbackByC', row)
      this.visible = false
    },
    /**
     * 选中或取消了运费券
     */
    checkCouponByF(){
      let row = {}
      if(this.fradio && this.fradio !== -1){
        this.useList.forEach(element => {
          if(element.userCouponId == this.fradio){
            row = element
          }
        });
      }
      if(this.fradio == -1){
        row.userCouponId = ''
        row.couponId = ''
        row.frightCouponCancel = 1,
        row.branchId = this.useList[0].branchId
      }
      this.$emit('checkCouponACallbackByF', row)
      this.visible = false
    }
  },
  created() {
    
  },
  computed: {},
  components: { EmptyItem }
};
</script>
<style lang="less" scoped>
.tou1{
  height:128px;
  line-height: 128px;
  font-size:32px;
  color: #000;
  width: 100%;
  border-bottom: 1PX solid #f7f7f7;
  .tou1-1{
    text-align: center;
    width:160px;
    margin-left: auto;
    margin-right: auto;
  }
}
.co0 {
  font-size: 20px;
  margin-bottom: 20px;
  .co1 {
    display: flex;
    .co1-1 {
      position: relative;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      text-align: center;
      padding-top: 22px;
      width: 280px;
      height: 158px;
      background-color: #FFFFFF;
      .co1-1-0{
        margin-top: 15px;
      }
      .cx{
        margin-top: 33px;
      }
      .co1-1-x{
        font-size: 36px;
        height:50px;
        line-height: 50px;
        color: #CCCCCC;
      }
      .co1-1-1 {
        width: 130px;
        height:67px;
        font-size: 48px;
        line-height: 67px;
        .co1-1-1-1 {
          width: 24px;
          height: 33px;
          font-size: 28px;
          font-weight: 500;
          line-height: 33px;
        }
      }
      .co1-1-2 {
        height: 33px;
        font-size: 24px;
        font-weight: 500;
        line-height: 33px;
      }
    }
    .index-list-lefts-1{
      position: absolute;
      width:91px;
      height:33px;
      border-radius:0px 100px 100px 0px;
      left: 0;
      top: 10px;
      font-size:20px;
      color: #fff;
      text-align: center;
      line-height: 33px;
    }
    .co1-2 {
      position: relative;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      padding-left: 38px;
      width: 450px;
      height: 180px;
      background-color: #FFFFFF;
      .co1-2-x{
        height:40px;
        font-size:28px;
        line-height: 40px;
        margin-top: 71px;
        color: #CCCCCC;
      }
      .co1-2-1 {
        width: 320px;
        height: 80px;
        font-size: 28px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
        margin-top: 19px;
        margin-bottom: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .co1-2-2-1 {
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: rgba(204, 204, 204, 1);
        line-height: 28px;
        margin-right: 23px;
      }
      .niu {
        position: absolute;
        right: 0;
        top: 0;
        margin-top: 76px;
        margin-right: 30px;
      }
    }
  }
}
.cor-1 {
  background-color: #F8A651;
  color:#F8A651;
}
.cor-2 {
  background-color: #409EFF;
  color: #409EFF;
}
.cor-3 {
  background-color: #CCCCCC;
  color: #CCCCCC;
}
.color1{
  background-color: #F8A651;
}
.color2{
  background-color: #409EFF;
}
.color3{
  background-color: #CCCCCC;
}
.zli {
  padding: 27px 20px 10px 20px;
  background-color: #F7F7F7;
  overflow: scroll;
  max-height: 600px;
}
.zul {
  text-align: center;
  padding-bottom: 60px;
  padding-top: 30px;
  width: 100%;
  .zfot {
    margin-left: 30%;
    text-align: center;
    font-size: 32px;
    width: 299px;
    height: 75px;
    line-height: 75px;
    background: rgba(248, 213, 65, 1);
    border-radius: 38px;
    color: #000000;
  }
}
</style>
